module.exports = __webpack_public_path__ + "img/1-ajouter-partenaire-SMUP.b9d52081.png";